import React, { useEffect } from "react";
import "./Wishlist.css";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import { useDispatch, useSelector } from "react-redux";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import Common_Product_Card from "../common_components/common_product_card/Common_Product_Card";
import { variant_type } from "../../utils/common";

const Wishlist = () => {
  const dispatch = useDispatch();
  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  const user = useSelector((state) => state.myaccount.addMyaccount);
  useEffect(() => {
    if (user?.id) {
      dispatch(getAllWishlist());
    }
  }, []);

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Wishlist", link: "", isActive: true },
  ];

  // console.log("allWishlist", allWishlist);

  const features = [
    "Dual Side usage",
    "Naturally Cooling Coir that refreshens you",
    "Firm back support",
    "Naturally Cooling Coir that refreshens you",
    "Firm back support",
  ];

  return (
    <section className="Wishlist">
      <div className="breadcrump_div">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />
      </div>

      <div className="container">
        <div className="row">
          {allWishlist?.data?.length > 0 ? (
            allWishlist?.data?.map((product) => {
              let metal;
              let size;
              let triple;
              if (
                Number(product?.Product?.variant_type_id) === Number(variant_type.Single)
              ) {
                metal = product?.Product?.Product_Variants?.[0];
              } else if (
                Number(product?.Product?.variant_type_id) === Number(variant_type.Double)
              ) {
                metal = product?.Product?.Product_Variants?.[0];
                size = metal?.Double_Variants?.[0];
              } else if (
                Number(product?.Product?.variant_type_id) === Number(variant_type.Triple)
              ) {
                metal = product?.Product?.Product_Variants?.[0];
                console.log(metal,"metal metal");
                
                size = metal?.Double_Variants?.[0];
                triple = size?.Triple_Variants?.[0];
              }

              const activeVariant = triple || size || metal;

              return (
                <div
                  className="col-xl-3 col-lg-4 col-sm-6 mb-5"
                  key={product?.id}
                >
                  <Common_Product_Card
                    product={product.Product}
                    id={product.Product?.id}
                    imgSrc={process.env.REACT_APP_IMG_URL + product.Product?.image}
                    vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                    productName={product.Product?.name}
                    sellingPrice={activeVariant?.price || 0}
                    mrp={activeVariant?.mrp || 0}
                    kgText={metal?.Metal?.name}
                    discount={
                      activeVariant?.mrp
                        ? (
                            ((parseFloat(activeVariant?.mrp || 0) -
                              parseFloat(activeVariant?.price || 0)) /
                              parseFloat(activeVariant?.mrp || 1)) *
                            100
                          ).toFixed(0)
                        : 0
                    }
                    feature={product?.Product?.Product_Fetures?.slice(0, 3)}
                    btnText={"Shop Now"}
                  />
                </div>
              );
            })
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "20px",
                fontWeight: "bold",
                width: "100%",
                color: "black",
              }}
            >
              Product Not Available
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Wishlist;
